import type { TimelineRow } from '@tabel/shared/agent-events/timeline';
import { ListChecks } from 'lucide-react';
import { memo } from 'react';

type Row = Extract<TimelineRow, { kind: 'sample' }>;

/**
 * Выборка дней вместо ответа инструмента (FR-062): «Выборка №N, K дней» или «Проверено на дне выборки №N: …» —
 * подпись с сервера. Самих дней в ленте нет.
 */
export const SampleRow = memo(function SampleRow({ row }: { row: Row }) {
  return (
    <div className="flex min-h-7 items-start gap-2 text-[13px] text-ink-2">
      <span className="flex h-5 w-4 shrink-0 items-center justify-center">
        <ListChecks size={16} strokeWidth={1.75} className="text-ink-3" aria-hidden />
      </span>
      <span className="min-w-0 py-0.5 leading-[1.4] break-words">{row.label}</span>
    </div>
  );
});
